import { useState } from 'react'
import type { EntryFilters } from '../hooks/useApi'
import { fromLocalInputValue, toLocalInputValue } from '../lib/format'
import { useT } from '../i18n/context'
import { useActiveWorkspaceId } from '../stores/workspace'
import { Card } from '../components/ui/Card'
import { Field } from '../components/ui/Field'
import { DateInput } from '../components/ui/DateTimeInputs'
import {
    EntriesCsvButton,
    EntriesTable,
    EntryFilterSelects,
} from '../components/EntriesList'

/** Abrechnung → Einträge: Filter (Projekt/Kunde/Typ/Von/Bis), Tabelle, CSV. */
export function EntriesPage() {
    const t = useT()
    const workspaceId = useActiveWorkspaceId()
    const [filters, setFilters] = useState<EntryFilters>({ page: 1 })

    const patch = (p: Partial<EntryFilters>) =>
        setFilters(f => ({ ...f, page: 1, ...p }))

    return (
        <div className='space-y-4'>
            <div className='flex flex-wrap items-end gap-2'>
                <EntryFilterSelects
                    workspaceId={workspaceId}
                    filters={filters}
                    onPatch={patch}
                />
                <Field label={t('entries.from')}>
                    <DateInput
                        value={
                            filters.startDate
                                ? toLocalInputValue(filters.startDate).slice(0, 10)
                                : ''
                        }
                        onChange={v =>
                            patch({
                                startDate: v
                                    ? fromLocalInputValue(`${v}T00:00`)
                                    : undefined,
                            })
                        }
                        className='w-40'
                    />
                </Field>
                <Field label={t('entries.to')}>
                    <DateInput
                        value={
                            filters.endDate
                                ? toLocalInputValue(filters.endDate).slice(0, 10)
                                : ''
                        }
                        onChange={v =>
                            patch({
                                endDate: v
                                    ? fromLocalInputValue(`${v}T23:59`)
                                    : undefined,
                            })
                        }
                        className='w-40'
                    />
                </Field>
                <EntriesCsvButton
                    workspaceId={workspaceId!}
                    filters={filters}
                    className='ml-auto'
                />
            </div>

            <Card>
                <EntriesTable
                    workspaceId={workspaceId}
                    filters={filters}
                    onPage={page => setFilters(f => ({ ...f, page }))}
                />
            </Card>
        </div>
    )
}
